import { AbilityBuilder,Ability  } from '@casl/ability'
const { can,build } = new AbilityBuilder(Ability);
can('test');
export default build();